<template>
  <div class="applicationWindow_index">
    <page-header :title="$tc('applicationWindow.name', 2)">
    </page-header>
    <page-content>
      <ntm-block :collapsable="false">
        <template slot="options">
          <div class="d-flex flex-wrap align-items-center mb-2">
            <button class="btn btn-sm mr-2" :class="{'btn-primary': isStatusSelected('active')}" @click="toggleStatus('active')">
              {{ $t('applicationWindow.active') }}
            </button>
            <button class="btn btn-sm mr-2" :class="{'btn-primary': isStatusSelected('upcoming')}" @click="toggleStatus('upcoming')">
              {{ $t('applicationWindow.upcoming') }}
            </button>
            <button class="btn btn-sm mr-2" :class="{'btn-primary': isStatusSelected('expired')}" @click="toggleStatus('expired')">
              {{ $t('applicationWindow.expired') }}
            </button>
            <button class="btn btn-sm mr-2" :class="{'btn-primary': isStatusSelected('archived')}" @click="toggleStatus('archived')">
              {{ $t('applicationWindow.archived') }}
            </button>
          </div>
          <input type="text" class="form-control" :placeholder="$t('search')" v-model="search">
          <button @click="createPage()" type="button" class="btn btn-sm btn-success">{{$t('action.addNew')}}</button>
        </template>
        <div class="table-responsive">
          <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading">
              <template v-slot:status="{row}">
                <span v-if="row.isArchived" class="badge badge-secondary mb-2">{{ $t('applicationWindow.archived') }}</span>
                <span v-else-if="row.isExpired" class="badge badge-danger">{{ $t('applicationWindow.expired') }}</span>
                <span v-else-if="row.isUpcoming" class="badge badge-info">{{ $t('applicationWindow.upcoming') }}</span>
                <span v-else class="badge badge-success">{{ $t('applicationWindow.active') }}</span>
              </template>
              <template v-slot:actions="{row}">
                <router-link :to="{ name: 'applicationWindow.show', params: {applicationWindow: row.uuid }}" class="btn btn-sm btn-primary" v-tooltip="$t('action.edit')">
                  <i class="fa fa-eye"></i>
                </router-link>
                <button v-if="!row.isArchived" class="btn btn-sm btn-warning" @click="archiveEntity(row.uuid)" v-tooltip="$t('applicationWindow.archive')">
                  <i class="fa fa-archive"></i>
                </button>
                <button v-else class="btn btn-sm btn-success" @click="restoreEntity(row.uuid)" v-tooltip="$t('applicationWindow.restored')">
                  <i class="fa fa-undo"></i>
                </button>
              </template>
          </ntm-table>
        </div>
      </ntm-block>
    </page-content>
  </div>
</template>
<script>
import ApplicationWindowService from '@/services/applicationWindow.service'
import router from '@/router'
import basicIndexMixin from '@/mixins/basic.index.mixin'
import { useRouteQuery } from '@/use/useRouteQuery'

export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        },
        {
          name: 'startDate',
          prop: 'startDate'
        },
        {
          name: 'endDate',
          prop: 'endDate'
        },
        {
          name: 'pendingApplications',
          prop: 'pendingApplicationsCount',
          type: 'badge'
        },
        {
          name: 'status'
        }
      ]
    }
  },
  setup () {
    const statuses = useRouteQuery('statuses', ['active', 'upcoming', 'expired'], 'multi')

    return { statuses }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    statuses () { this.page = 1; this.fetchData() }
  },
  methods: {
    isStatusSelected (status) {
      return this.statuses.includes(status)
    },
    toggleStatus (status) {
      if (this.isStatusSelected(status)) {
        this.statuses = this.statuses.filter(s => s !== status)
      } else {
        this.statuses = [...this.statuses, status]
      }
    },
    archiveEntity (uuid) {
      if (!window.confirm(this.$t('applicationWindow.archiveConfirm'))) { return }
      ApplicationWindowService.archive(uuid).then(() => {
        this.fetchData()
      })
    },
    restoreEntity (uuid) {
      if (!window.confirm(this.$t('applicationWindow.restoreConfirm'))) { return }
      ApplicationWindowService.restore(uuid).then(() => {
        this.fetchData()
      })
    },
    fetchData () {
      ApplicationWindowService.index({
        page: this.page,
        search: this.search,
        isArchived: this.isStatusSelected('archived') || false,
        isExpired: this.isStatusSelected('expired') || undefined,
        isUpcoming: this.isStatusSelected('upcoming') || undefined,
        isActive: this.isStatusSelected('active') || undefined
      }).then((response) => {
        this.setData(response.data)
      })
    },
    createPage () {
      router.push({ name: 'applicationWindow.create' })
    }
  }
}
</script>
